class TopSearch {
	private showSeachButton = document.querySelector(".show-search");
	private closeSearchButton = document.querySelector(".close-search");
	private pageHeader = document.querySelector(".page-header");

	init() {
		this.showSeachButton?.addEventListener("click", () => {
			this.pageHeader?.classList.add("search");
		});
		this.closeSearchButton?.addEventListener("click", () => {
			this.pageHeader?.classList.remove("search");
		});
	}
}

document.addEventListener("DOMContentLoaded", () => {
	const topSearch = new TopSearch();

	topSearch.init();
});
